module.exports = __webpack_public_path__ + "img/azxy20.89e4cd3f.png";